import { setUrls, urls } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { observeStore, store } from 'Utilities/store';
import { CONFIG_UPDATE } from 'src/reducers/config/types';

// import { CONFIG_UPDATE } from 'Constants/actionTypes';

const _getConfigWithCountry = country => {
  return new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'POST',
      url: urls.lslApi + 'oauth2/config',
      data: {
        country
      }
    }).then(result => {
      if (result.status === 0) {
        resolve(result.data);
      } else {
        reject(result);
      }
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
const handleGetBase = request => {
  request.response = new Promise((resolve, reject) => {
    mediator.request('api:invoke', {
      method: 'GET',
      url: urls.lslApi + 'oauth2/config/base'
    }).then(result => resolve(result.data)).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
const handleUpdateConfig = request => {
  request.response = new Promise((resolve, reject) => {
    _getConfigWithCountry(request.country).then(res => {
      if (store) {
        store.dispatch({
          type: CONFIG_UPDATE,
          config: res,
          country: request.country
        });
      }

      // this allows a service to wait until an update is done
      mediator.publish('config:UpdatedConfigForCountry', {
        country: request.country
      });
      resolve(res);
    }).catch(err => {
      // what do we do here?
      log.error(err);
      // mediator.publish('config:UpdatedConfigForCountry', {
      //   error: {
      //     status: err.status,
      //   },
      // });
      reject(err);
    });
  });
};
mediator.once('store:created', () => {
  // Update the service urls when config changes
  observeStore(state => state.config, setUrls);
  // Update when user country changes
  // observeStore(
  //   store,
  //   (state) => state.user.country,
  //   (country: string) => handleUpdateConfig({ country })
  // );
});
mediator.subscribe('config:getBase', handleGetBase);
mediator.subscribe('config:updateConfig', handleUpdateConfig);